module.exports = __webpack_public_path__ + "media/images/number_22-559a94fed19a0e440a150e44986f8d88.png";